import ScalarSidebarSearchButton_vue_vue_type_script_setup_true_lang_default from "./ScalarSidebarSearchButton.vue.script.js";
//#region src/components/ScalarSidebar/ScalarSidebarSearchButton.vue
var ScalarSidebarSearchButton_default = ScalarSidebarSearchButton_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarSidebarSearchButton_default as default };

//# sourceMappingURL=ScalarSidebarSearchButton.vue.js.map